import React, { useRef, useEffect } from "react"

import CompNav from '../CompNav'

const FormWrapper = ({
  children,
  isLastStep,
  goToPreviousStep,
  canGoBack,
  actionLabel,
  currentStep,
  wizard,
  status,
}) => {
  // eslint-disable-next-line

  const startPos = useRef(null)

  useEffect(() => {
    // eslint-disable-next-line
    startPos.current?.scrollIntoView({ behavior: "smooth" })
  }, [])

  return (
    <>
      <div  className="" />
      <CompNav currentStep={currentStep} wizard={wizard} />
      <div className="p-lg-5 p-4">
        {children}
        <div className="form-row justify-between pt-5">
          <div className="form-group col-md-5 my-3">
            <button
              type="button"
              onClick={goToPreviousStep}
              disabled={!canGoBack}
              className={
                !canGoBack
                  ? "d-none"
                  : "btn sparkle--button__green_outline px-5 w-100 btn-block"
              }
            >
              Previous
            </button>
          </div>

          <div className="form-group col-md-5 my-3">
            <button
              type="submit"
              className="btn sparkle--button__green sparkle--button__shadow px-5 btn-block w-100"
            >
              {actionLabel || (isLastStep ? "Submit" : "Next step")}
            </button>
          </div>
        </div>

        
      </div>
    </>
  )
}

export default FormWrapper
